import { UPDATE_DMX_CONTROLLER, UPDATE_DMX_CONTROLLER_SUCCESSFUL, UPDATE_DMX_CONTROLLER_FAILED } from './actionTypes';

const initialState = {
  updateDmxControllerError: null,
  messageDmxController: null,
  loadingUpdateDmxController: false,
};

const updateController = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_DMX_CONTROLLER:
      state = { ...state, loadingUpdateDmxController: true, updateDmxControllerError: null };
      break;
    case UPDATE_DMX_CONTROLLER_SUCCESSFUL:
      state = { ...state, loadingUpdateDmxController: false, messageDmxController: action.payload, updateDmxControllerError: null };
      break;
    case UPDATE_DMX_CONTROLLER_FAILED:
      state = { ...state, messageDmxController: null, loadingUpdateDmxController: false, updateDmxControllerError: action.payload };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default updateController;
